import { all, call, put, takeLatest } from "redux-saga/effects";

import {
  getLaborContractStart,
  getLaborContractSuccess,
  getLaborContractFailed,
} from "../redux/getLaborContract";
import { getLaborContractApi } from "core/http/service/operationProcess";

function* getLaborContractWork() {
  try {
    const res = yield call(getLaborContractApi);
    yield put({
      type: getLaborContractSuccess.type,
      payload: res,
    });
  } catch (error: any) {
    yield put({
      type: getLaborContractFailed.type,
    });
  }
}
function* watchGetLaborContract() {
  yield takeLatest(getLaborContractStart.type, getLaborContractWork);
}

export default function* getLaborContractSaga() {
  yield all([watchGetLaborContract()]);
}
